const SeveritySuccess = ({ width = "13", height = "13" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Severity Icons">
      <path
        id="primary-shape"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.238281 6.02539C0.238281 2.71168 2.92457 0.0253906 6.23828 0.0253906C7.82958 0.0253906 9.3557 0.657532 10.4809 1.78275C11.6061 2.90797 12.2383 4.43409 12.2383 6.02539C12.2383 9.3391 9.55199 12.0254 6.23828 12.0254C2.92457 12.0254 0.238281 9.3391 0.238281 6.02539ZM6.07628 8.19139L8.81828 4.59139V4.57339C8.94904 4.4019 8.97838 4.17368 8.89525 3.9747C8.81211 3.77571 8.62914 3.6362 8.41525 3.6087C8.20135 3.5812 7.98904 3.6699 7.85828 3.84139L5.59028 6.84139L4.61228 5.59339C4.48045 5.42405 4.26829 5.3379 4.05572 5.36739C3.84315 5.39689 3.66246 5.53755 3.58172 5.73639C3.50098 5.93524 3.53245 6.16205 3.66428 6.33139L5.12828 8.19739C5.24277 8.34229 5.41761 8.42639 5.60228 8.42539C5.78798 8.42494 5.96301 8.33854 6.07628 8.19139Z"
        fill="#31BF7B"
      />
    </g>
  </svg>
);

export default SeveritySuccess;
